import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button-tw";
import { cn } from "@/utils/classnames";
import { useDeleteContact } from "@/hooks/contact/use-delete-contact";

export default function DeleteContactAlert() {
  const history = useHistory();
  const location = useLocation();
  const { mutate: deleteContact, isLoading: deleting } = useDeleteContact();
  const queryParams = new URLSearchParams(location.search);

  const dialogOpen = queryParams.has("delete_contact");
  const contactId = queryParams.get("delete_contact");

  const closeDialog = () => {
    if (queryParams.has("delete_contact")) {
      queryParams.delete("delete_contact");
      history.replace({
        search: queryParams.toString(),
      });
    }
  };

  return (
    <AlertDialog open={dialogOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Double checking...</AlertDialogTitle>
          <AlertDialogDescription>
            <span
              className={cn(
                "text-sm text-muted-foreground text-center sm:text-left"
              )}
            >
              Are you sure you'd like to delete this contact?
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            disabled={deleting}
            onClick={() => {
              closeDialog();
            }}
          >
            Cancel
          </AlertDialogCancel>
          <Button
            variant="destructive"
            onClick={() => {
              deleteContact(contactId, {
                onSuccess: () => {
                  toast.success("Your contact has been deleted.");
                  closeDialog();
                },
              });
            }}
            disabled={deleting}
          >
            Delete
            {deleting && <Loader2 className="w-4 h-4 ml-2 animate-spin" />}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
